import { decl } from '@yandex-lego/i-bem-react';

export default decl({
    block: 'copyright',
    elem: 'dates',
    tag: 'span',
    content: function content() {
        var start = this.props.start,
            currentYear = new Date().getFullYear();


        return [start && start !== currentYear && start + '–', currentYear];
    }
});